import BigNumber from "bignumber.js";

export const BN = BigNumber.clone({ EXPONENTIAL_AT: 500 }); // Number 500 becomes scientific notation

export default BN;

export class Calc {
  static BN = BigNumber.clone({
    EXPONENTIAL_AT: 500,
    ROUNDING_MODE: 1,
  });

  static setBN(obj) {
    this.BN.set(obj);

    return this;
  }

  static init(base) {
    this.base = new this.BN(base, 10);

    return this;
  }

  /**
   * addition
   * @param base cardinality
   * @returns
   */
  static plus(base) {
    this.base = this.base.plus(new this.BN(base, 10));

    return this;
  }

  /**
   * subtraction
   * @param base cardinality
   * @returns
   */
  static minus(base) {
    this.base = this.base.minus(new this.BN(base, 10));

    return this;
  }

  /**
   * multiplication
   * @param base cardinality
   * @returns
   */
  static multiply(base) {
    this.base = this.base.multipliedBy(new this.BN(base, 10));

    return this;
  }

  /**
   * division
   * @param base cardinality
   * @returns
   */
  static div(base) {
    if (Number(base) === 0) return this;

    this.base = this.base.div(new this.BN(base, 10));

    return this;
  }

  static result(format = true) {
    return format ? this.base.toFormat() : this.base.valueOf();
  }
}
